import { TS_ItemInterface } from 'Models/TravelSeller/Models/TS_ItemInterface';
import { TS_ItemType }      from './TS_ItemType';
import { TS_Addon }         from './TS_Addon';


export class TS_AddonBus extends TS_Addon implements TS_ItemInterface {
    type = TS_ItemType.ARRIVAL_BY_BUS;
}
